import React from "react";
import { withRouter, Link } from "react-router-dom";
import texts from "Texts/partner";
import { TextBlock, ContactsBlock } from "ComponentsUI/InfoBlocks";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { inject, observer } from "mobx-react";
import { flowRight as compose } from "lodash";
import { graphql } from "@apollo/client/react/hoc";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { SITE_CONFIG_QUERY } from "Services/queries";
import Routes from "Configs/routes";
import Container from "reactstrap/lib/Container";
import { PhoneForm } from "../componentsUI/InfoBlocks";
import Block from "ComponentsUI/Block";
import TermsOfUse from "ComponentsUI/TermsOfUse";
import { isMainSiteCode } from "Utils/siteConfig";

@inject("ApplicationModel")
@observer
class PartnersContainer extends React.Component {
	isSending = false;

	constructor(props) {
		super(props);
		this.state = {
			error: {
				name: false,
				phone: false,
			},
			name: "",
			phone: "",
			wasSended: false,
			globalError: false,
		};
	}

	changeState(name, value) {
		if (this.state[name] === value) {
			return;
		}

		this.setState({
			...this.state,
			[name]: value,
			error: {
				...this.state.error,
				[name]: false,
			},
		});
	}

	submit() {
		let {
			ApplicationModel: { sendingStore },
		} = this.props;

		let isError = false;

		if (this.isSending) {
			return;
		}

		if (!this.state.name.length) {
			this.setState((state) => ({
				error: {
					...state.error,
					name: true,
				},
			}));

			isError = true;
		}

		if (!sendingStore.validatePhone(this.state.phone)) {
			this.setState((state) => ({
				error: {
					...state.error,
					phone: true,
				},
			}));
			isError = true;
		}

		if (isError || this.isSending) {
			return;
		}

		this.isSending = true;

		let data = {
			name: this.state.name,
			phone: this.state.phone,
			type: 11,
		};

		sendingStore
			.onSendFeedback(data)
			.then(() => {
				this.setState({
					wasSended: true,
				});
			})
			.catch(() => {
				this.setState({
					globalError: true,
				});
			})
			.finally(() => {
				this.isSending = false;
			});
	}

	render() {
		const email = this.props?.siteConfigLoader?.data?.siteConfig?.email;
		let text = this.props.ApplicationModel.text;
		const siteCode = this.props.ApplicationModel.siteCode;
		const contactsFirstBlock = [];

		let feedbackUrl = generateUrl(Routes.ContactFeedback.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		let feedbackLink = <Link to={!!feedbackUrl ? feedbackUrl : "/"} />;

		if (email) {
			contactsFirstBlock.push({
				name: "e-mail",
				value: email,
				isEmail: true,
			});
		}

		return (
			<>
				{isMainSiteCode(siteCode) && <div></div>}
				<PaddingBottom>
					<div>
						<Block header={text.SET_PARTNERSHIP} headerWithoutMargin={true}>
							<Container>
								<TextBlock withoutPadding={true} text={texts.main} insertDangerous={true} />
								<PhoneForm
									text={text}
									data={this.state}
									changeData={(name, value) => this.changeState(name, value)}
									onSubmit={() => this.submit()}
								/>
								{!this.state.wasSended && <TermsOfUse isPartners={true} buttonText={text.SEND} />}
							</Container>
						</Block>
					</div>
					<div>
						<Container>
							<ContactsBlock
								header={text.FEEDBACK}
								data={contactsFirstBlock}
								buttonName={text.FEEDBACK}
								buttonLink={feedbackLink}
							/>
						</Container>
					</div>
				</PaddingBottom>
			</>
		);
	}
}

export default withRouter(
	withDefaultParams(
		compose(
			graphql(SITE_CONFIG_QUERY, {
				props: (responseProps) => {
					return {
						siteConfigLoader: responseProps,
					};
				},
			})
		)(PartnersContainer)
	)
);
